import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError, take, switchMap } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(): Observable<boolean> {
    // If already authenticated, allow immediately
    if (this.auth.isAuthenticated) {
      return of(true);
    }

    // Otherwise wait for the auth check to complete (handles page refresh)
    return this.auth.checkAuth().pipe(
      map(res => {
        if (res?.authenticated) {
          return true;
        }
        this.router.navigate(['/login']);
        return false;
      }),
      catchError(() => {
        this.router.navigate(['/login']);
        return of(false);
      }),
      take(1)
    );
  }
}
